module.exports = __webpack_public_path__ + "img/reward.e4653861.svg";